import { render } from "./User.vue?vue&type=template&id=3851b662&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=3851b662&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3851b662"

export default script